var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.view,_vm._b({tag:"component",on:{"go":_vm.linkname}},'component',_vm.props,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }